
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowRight, BarChart3, DollarSign, FileCheck, Upload } from "lucide-react";
import { Link } from "react-router-dom";

const Sell = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-primary/10 to-primary/5 py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl font-bold mb-6">Turn Your Automation Skills Into Income</h1>
              <p className="text-xl text-muted-foreground mb-8">
                Share your expertise with thousands of users looking for ready-made workflow solutions
              </p>
              <Link to="/auth?action=signup">
                <Button size="lg" className="px-8">
                  Start Selling Now <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
        
        {/* How It Works */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <Card>
                <CardHeader className="text-center">
                  <div className="mx-auto bg-primary/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                    <Upload className="h-8 w-8 text-primary" />
                  </div>
                  <CardTitle>Create & Upload</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-center">
                    Package your best automation workflows into easy-to-use templates and upload them to our marketplace.
                  </p>
                </CardContent>
              </Card>
              
              <Card>
                <CardHeader className="text-center">
                  <div className="mx-auto bg-primary/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                    <DollarSign className="h-8 w-8 text-primary" />
                  </div>
                  <CardTitle>Set Your Price</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-center">
                    Decide how much your expertise is worth. Set competitive prices for your workflows.
                  </p>
                </CardContent>
              </Card>
              
              <Card>
                <CardHeader className="text-center">
                  <div className="mx-auto bg-primary/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                    <BarChart3 className="h-8 w-8 text-primary" />
                  </div>
                  <CardTitle>Earn & Grow</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-center">
                    Get paid when users purchase your workflows. Build your reputation and audience.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
        
        {/* Seller Benefits */}
        <section className="py-16 bg-secondary/50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Why Sell on FlowMarket</h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="flex flex-col items-center text-center p-4">
                <FileCheck className="h-12 w-12 text-primary mb-4" />
                <h3 className="text-xl font-semibold mb-2">Ready-Made Audience</h3>
                <p className="text-muted-foreground">Reach thousands of users actively looking for solutions like yours</p>
              </div>
              
              <div className="flex flex-col items-center text-center p-4">
                <DollarSign className="h-12 w-12 text-primary mb-4" />
                <h3 className="text-xl font-semibold mb-2">Competitive Commissions</h3>
                <p className="text-muted-foreground">Keep up to 95% of your sales with our industry-leading rates</p>
              </div>
              
              <div className="flex flex-col items-center text-center p-4">
                <BarChart3 className="h-12 w-12 text-primary mb-4" />
                <h3 className="text-xl font-semibold mb-2">Detailed Analytics</h3>
                <p className="text-muted-foreground">Track your performance with comprehensive sales and user data</p>
              </div>
              
              <div className="flex flex-col items-center text-center p-4">
                <Upload className="h-12 w-12 text-primary mb-4" />
                <h3 className="text-xl font-semibold mb-2">Simple Upload Process</h3>
                <p className="text-muted-foreground">Our streamlined platform makes it easy to list and manage your workflows</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* CTA Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-6">Ready to Share Your Expertise?</h2>
              <p className="text-xl text-muted-foreground mb-8">
                Join our community of automation experts and start earning today.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/auth?action=signup">
                  <Button size="lg" className="w-full sm:w-auto">
                    Create Seller Account
                  </Button>
                </Link>
                <Link to="/seller-guide">
                  <Button variant="outline" size="lg" className="w-full sm:w-auto">
                    View Seller Guide
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Sell;
